// Dutch
export const nl = {
  'app.name':           'Kardolive',
  'app.tagline':        'Klantenportaal',
  'app.signOut':        'Uitloggen',

  'login.email':        'E-mail',
  'login.password':     'Wachtwoord',
  'login.signIn':       'Inloggen',
  'login.signingIn':    'Bezig met inloggen…',
  'login.failed':       'Inloggen mislukt',
  'login.newAccount':   'Nieuw bij Kardolive?',
  'login.createAccount':'Maak een gratis account →',

  'nav.workspace':      'Werkruimte',
  'nav.templates':      'Sjablonen',
  'nav.live':           'Live',
  'nav.rooms':          'Ruimtes & chat',
  'nav.content':        'Inhoud',
  'nav.developer':      'Ontwikkelaar',
  'nav.account':        'Account',

  'nav.overview':       'Overzicht',
  'nav.projects':       'Projecten',
  'nav.chat':           'Chatconsole',
  'nav.sessions':       'Sessies',
  'nav.streams':        'Live streams',
  'nav.studio':         'Studio',
  'nav.recordings':     'Opnames',
  'nav.apiKeys':        'API-sleutels',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook-tester',
  'nav.networkTest':    'Netwerktest',
  'nav.embed':          'Ingesloten widgets',
  'nav.sdk':            'SDK\'s en documentatie',
  'nav.docs':           'Ontwikkelaarsdocs',
  'nav.analytics':      'Analyse',
  'nav.settings':       'Instellingen',

  'overview.welcome':       'Welkom terug, {name}',
  'overview.plan':          '{tenant} · {plan}-abonnement',
  'overview.newStream':     'Nieuwe stream',
  'overview.kpi.live':           'Nu live',
  'overview.kpi.live.broadcasting': 'streams worden uitgezonden',
  'overview.kpi.live.nothing':    'niets live',
  'overview.kpi.total':           'Totaal aantal streams',
  'overview.kpi.total.sub':       'aller tijden',
  'overview.kpi.sessions':        'Sessies · 30 dagen',
  'overview.kpi.sessions.sub':    'publicatie-evenementen',
  'overview.kpi.recordings':      'Opnames',
  'overview.kpi.recordings.sub':  'klaar om af te spelen',
  'overview.recentStreams':       'Recente streams',
  'overview.recentSessions':      'Recente sessies',
  'overview.viewAll':             'Alles bekijken →',
  'overview.empty.title':         'Nog geen streams',
  'overview.empty.body':          'Maak je eerste stream om te beginnen met uitzenden.',
  'overview.empty.action':        'Stream maken',
  'overview.noSessions':          'Nog geen sessies',

  'status.live':        'LIVE',
  'status.idle':        'INACTIEF',
  'status.ended':       'BEËINDIGD',
  'status.archived':    'GEARCHIVEERD',

  'common.save':        'Opslaan',
  'common.cancel':      'Annuleren',
  'common.delete':      'Verwijderen',
  'common.edit':        'Bewerken',
  'common.create':      'Maken',
  'common.confirm':     'Bevestigen',
  'common.loading':     'Laden…',
  'common.error':       'Fout',
  'common.retry':       'Opnieuw proberen',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Naar de pagina-inhoud",
  "nav.streamTemplates": "Streamsjablonen",
  "nav.boards": "Interactieve borden",
  "nav.menu": "Navigatie openen",
  "nav.closeMenu": "Navigatie sluiten",
  "nav.scenarios": "Scenario’s",
  "nav.premieres": "Premières",
  "nav.clips": "Clips",
  "dashboard.account": "Account",
  "dashboard.language": "Taal",
  "dashboard.appearance": "Weergave",
  "nav.allStreams": "Alle streams",
  "nav.destinations": "Bestemmingen",
  "nav.ecommerce": "E-commerce",
  "nav.products": "Producten",
  "nav.services": "Diensten",
  "nav.collections": "Collecties",
  "nav.orders": "Bestellingen",
  "nav.commerceSettings": "Handelsinstellingen",
  "nav.engagement": "Interactie",
  "theme.light": "Overschakelen naar lichte modus",
  "theme.dark": "Overschakelen naar donkere modus",
  "role.owner": "Eigenaar",
  "role.admin": "Beheerder",
  "role.member": "Lid",
  "role.viewer": "Toeschouwer",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Actief",
  "streams.archived": "Gearchiveerd",
  "streams.monitor": "Signaalmonitor",
  "streams.create": "Livestream maken",
  "streams.list": "Lijst",
  "streams.grid": "Raster",
  "streams.view": "Streamweergave",
  "streams.searchLabel": "Evenementen zoeken",
  "streams.searchHint": "Zoeken op naam",
  "streams.solutionFilter": "Evenementen filteren op type",
  "streams.statusFilter": "Evenementen filteren op status",
  "streams.dateFilter": "Filteren op aanmaakdatum",
  "streams.allSolutions": "Alle typen",
  "streams.custom": "Bestaande of aangepaste opzet",
  "streams.allStatuses": "Alle statussen",
  "streams.anyTime": "Elke aanmaakdatum",
  "streams.last7": "Aangemaakt in de afgelopen 7 dagen",
  "streams.last30": "Aangemaakt in de afgelopen 30 dagen",
  "streams.count": "{shown} van {total} evenementen weergegeven",
  "streams.noMatch": "Geen evenementen voldoen aan de filters.",
  "streams.clearFilters": "Filters wissen",
  "streams.refreshFailed": "De streamlijst kon niet worden vernieuwd",
  "streams.loadFailed": "De streams konden niet worden geladen",
  "streams.stale": "De laatst geladen lijst wordt getoond. De status kan gewijzigd zijn.",
  "streams.connectionHint": "Controleer je verbinding en laad de lijst opnieuw.",
  "streams.retrying": "Opnieuw proberen…",
  "streams.retry": "Opnieuw proberen",
  "streams.restoreFailed": "De stream kon niet worden hersteld",
  "streams.restoreHint": "Controleer je verbinding en vernieuw de lijst om de status te controleren voordat je het opnieuw probeert.",
  "streams.unused": "Ongebruikte streams: {count}",
  "streams.unusedHint": "Geen uitzendingen of herhalingen. Archiveer deze streams om op te ruimen; er wordt niets verwijderd.",
  "streams.reviewArchive": "Bekijken en archiveren",
  "streams.loading": "Streams laden…",
  "streams.archiveEmpty": "Niets gearchiveerd. Gearchiveerde streams en hun herhalingen blijven hier staan totdat je ze herstelt.",
  "streams.restore": "Herstellen",
  "streams.firstTitle": "Maak je eerste stream",
  "streams.firstBody": "Kies een opzet voor verkoop, lessen of diensten, of begin met een lege stream. Zend uit via je browser, telefoon of OBS.",
  "streams.blank": "Lege stream",
  "streams.broadcasts": "Uitzendingen: {count}",
  "streams.replays": "Herhalingen: {count}",
  "streams.sessions": "Sessies: {count}",
  "streams.recordings": "Opnamen: {count}",
  "streams.mode.BROADCAST": "Uitzending",
  "streams.mode.LOW_LATENCY": "Lage vertraging",
  "streams.mode.REALTIME": "Realtime",
  "streams.key": "Sleutel",
  "streams.archiveTitle": "Ongebruikte streams archiveren",
  "streams.archiveHint": "Deze streams zijn nooit uitgezonden. Je kunt ze altijd herstellen via het tabblad Gearchiveerd.",
  "streams.archiveFailed": "{count} streams konden niet worden gearchiveerd; ze zijn mogelijk live gegaan. De overige zijn gearchiveerd.",
  "streams.archiving": "Archiveren…",
  "streams.archiveCount": "{count} archiveren",
  "streamType.webinar": "Zakelijke webinars en lanceringen",
  "streamType.classroom": "Lessen en bijles",
  "streamType.training": "Bedrijfstrainingen",
  "streamType.conference": "Conferenties en beurzen",
  "streamType.shopping": "Live winkelen",
  "streamType.auction": "Live veilingen",
  "streamType.consultation": "Privéconsulten",
  "streamType.creator": "Creator- en communitystreams",
  "streamType.audio": "Audioruimtes en podcasts",
  "streamType.sports": "Sport en e-sport",
  "streamType.performance": "Concerten en optredens",
  "streamType.community": "Erediensten en fondsenwerving",
  "streamType.tour": "Rondleidingen en demonstraties",
  "streamType.fitness": "Fitness en workshops",
  "streamType.public-meeting": "Nieuws en openbare bijeenkomsten",
  "streamType.continuous": "Doorlopende kanalen en camera’s",
  "streams.close": "Sluiten",
};
